/**
 * Org-scoped version of generateSkillsPageUrl from skills-common/private/utils/skillLinkUtils.ts.
 *
 * Differences from the original:
 * - Accepts orgSlug instead of programSlug
 * - Generates links using /organizations/:orgSlug/skills/:skillId instead of /programs/:programSlug/skills/:skillId
 */
export const generateOrgScopedSkillsPageUrl = (skillId: string, orgSlug: string): string => {
  const encodedSkillId = encodeURIComponent(skillId);
  return `/organizations/${orgSlug}/skills/${encodedSkillId}`;
};
